import { useTheme } from 'styled-components';
import { Flex } from 'core/components';
import React from 'react';

export default function OverriddenIcon() {
  const theme = useTheme();
  const fill = theme.colors.primary;
  return (
    <Flex title="Edited">
      <svg width="16" height="17" viewBox="0 0 16 17" fill={fill} xmlns="http://www.w3.org/2000/svg">
        {/* eslint-disable-next-line max-len */}
        <path d="M8 2.50244C4.68594 2.50244 2 5.18838 2 8.50244C2 11.8165 4.68594 14.5024 8 14.5024C11.3141 14.5024 14 11.8165 14 8.50244C14 5.18838 11.3141 2.50244 8 2.50244ZM8.9375 7.93994C9.24922 7.93994 9.5 8.19307 9.5 8.50244C9.5 8.81182 9.24805 9.06494 8.9375 9.06494H6.875V10.3774H9.6875C9.99805 10.3774 10.25 10.6294 10.25 10.9399C10.25 11.2505 9.99922 11.5024 9.6875 11.5024H6.3125C6.00313 11.5024 5.75 11.2517 5.75 10.9399V6.06494C5.75 5.75557 6.00313 5.50244 6.3125 5.50244H9.6875C9.99922 5.50244 10.25 5.75557 10.25 6.06494C10.25 6.37432 9.99922 6.62744 9.6875 6.62744H6.875V7.93994H8.9375Z" />
      </svg>
    </Flex>
  );
}
